import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

export const getCustomer = id =>
  services
    .createClient('widgetBff')
    .then(client =>
      client.get(`customers/${id}`, { headers: getParameterHeaders() })
    )
    .then(res => res.data)

export const upsertUser = user =>
  services
    .createClient('widgetBff')
    .then(client =>
      client.post(`customers`, user, { headers: getParameterHeaders() })
    )
    .then(res => res.data)
